import React, { useEffect, useState } from "react";

const NAV_LINKS = [
  { label: "About",      href: "#about" },
  { label: "Networking", href: "#networking" },
  { label: "Speakers",   href: "#speakers" },
  { label: "Sponsors",   href: "#sponsors" },
  // { label: "Awards",     href: "#awards" },
  { label: "Contact",    href: "#contact" },
];

const MOBILE_BREAKPOINT = 1024;

const eventNavStyles = `

  @keyframes freedomPulse {
    0%, 100% { box-shadow: 0 0 0 0 rgba(255,149,0,.55), 0 0 0 0 rgba(200,16,46,.35); }
    50% { box-shadow: 0 0 10px 4px rgba(255,149,0,.3), 0 0 22px 8px rgba(200,16,46,.12); }
  }
  @keyframes sparkSpin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
  .en-spark {
    display: inline-block;
    animation: sparkSpin 3s linear infinite;
  }
  .en-btn {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: linear-gradient(135deg, #FF9500 0%, #C8102E 50%, #1A2B5F 100%);
    color: #fff;
    font-family: 'Poppins', sans-serif;
    font-weight: 700;
    font-size: 0.82rem;
    padding: 10px 20px;
    border-radius: 50px;
    text-decoration: none;
    white-space: nowrap;
    flex-shrink: 0;
    cursor: pointer;
    border: none;
    animation: freedomPulse 2s infinite;
    transition: opacity 0.2s;
  }
  .en-btn:hover { opacity: 0.9; }

  .en-brand-text {
    font-family: 'Playfair Display', serif;
    font-weight: 800;
    font-size: 1.25rem;
    line-height: 1;
    color: #1a1f2e;
    white-space: nowrap;
  }

  @media (max-width: 480px) {
    .en-brand-text { font-size: 0.85rem; }
    .me-hero-title .line1 { font-size: clamp(2.4rem, 11vw, 3.2rem); }
  .me-hero-title .line2 { font-size: clamp(1.6rem, 6.5vw, 2.2rem); }
  }

  @media (prefers-reduced-motion: reduce) {
    .en-spark { animation: none; }
    .en-btn { animation: none; }
  }
`;

const S = {
  header: (scrolled, isMobile) => ({
    position: "fixed",
    top: 0, left: 0, right: 0,
    zIndex: 100,
    padding: isMobile ? "8px 0 2px" : (scrolled ? "10px 0" : "16px 0"),
    transition: "padding 0.3s",
  }),
  inner: (isMobile) => ({
    maxWidth: 1200,
    margin: "0 auto",
    padding: isMobile ? "0 12px" : "0 20px",
  }),
  nav: () => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    background: "rgba(255,255,255,0.95)",
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    boxShadow: "0 4px 24px rgba(0,0,0,0.10), inset 0 1px 0 rgba(255,255,255,0.3)",
    border: "1px solid rgba(255,255,255,0.3)",
    borderRadius: 50,
    padding: "6px 14px",
    transition: "box-shadow 0.3s, background 0.3s",
    gap: 12,
  }),
  brand: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    textDecoration: "none",
    flexShrink: 0,
    minWidth: 0,
  },
  logoWrap: {
    width: 32, height: 32,
    borderRadius: 10,
    overflow: "hidden",
    background: "#f5f5f5",
    display: "flex", alignItems: "center", justifyContent: "center",
    flexShrink: 0,
  },
  logoImg: { width: "100%", height: "100%", objectFit: "contain" },
  brandSpan: { color: "#f37c23" },
  desktopLinks: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    listStyle: "none",
    margin: 0, padding: 0,
    flex: 1,
    justifyContent: "center",
  },
  link: (hovered) => ({
    display: "block",
    padding: "8px 14px",
    borderRadius: 50,
    fontSize: "0.85rem",
    fontWeight: 500,
    color: "#1a1f2e",
    background: hovered ? "rgba(0,0,0,0.06)" : "transparent",
    textDecoration: "none",
    transition: "background 0.2s",
    whiteSpace: "nowrap",
    outline: "none",
    cursor: "pointer",
  }),
  hamburger: {
    width: 36, height: 36,
    borderRadius: "50%",
    background: "rgba(255,255,255,0.9)",
    border: "1.5px solid #e4e8f1",
    display: "flex", alignItems: "center", justifyContent: "center",
    cursor: "pointer",
    flexShrink: 0,
    minWidth: 36,
  },
  mobileMenu: {
    margin: "8px 0 0",
    background: "rgba(255,255,255,0.98)",
    backdropFilter: "blur(16px)",
    borderRadius: 24,
    boxShadow: "0 8px 32px rgba(0,0,0,0.12)",
    padding: "12px",
    border: "1px solid #e4e8f1",
  },
  mobileLink: {
    display: "block",
    padding: "12px 16px",
    borderRadius: 14,
    fontSize: "0.92rem",
    fontWeight: 500,
    color: "#374151",
    textDecoration: "none",
    transition: "background 0.15s",
    cursor: "pointer",
  },
  mobileBtnWrap: { padding: "8px 0 4px" },
  mobileBtn: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: 8,
    width: "100%",
    background: "linear-gradient(135deg, #FF9500 0%, #C8102E 50%, #1A2B5F 100%)",
    color: "#fff",
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 700,
    fontSize: "0.9rem",
    padding: "13px 20px",
    borderRadius: 50,
    textDecoration: "none",
    transition: "opacity 0.2s",
    border: "none",
    cursor: "pointer",
  },
};

const scrollToSection = (href) => {
  const target = document.querySelector(href);
  if (target) {
    const top = target.getBoundingClientRect().top + window.scrollY - 80;
    window.scrollTo({ top, behavior: "smooth" });
  }
};

const NavLink = ({ href, label }) => {
  const [hovered, setHovered] = useState(false);
  return (
    <li>
      <a
        href={href}
        onClick={(e) => { e.preventDefault(); scrollToSection(href); }}
        style={S.link(hovered)}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {label}
      </a>
    </li>
  );
};

const ArrowIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" width="12" height="12">
    <path d="M5 12H19" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" />
    <path d="M13 6L19 12L13 18" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const HamburgerIcon = ({ open }) =>
  open ? (
    <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
      <path d="M18 6L6 18M6 6L18 18" stroke="#1a1f2e" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  ) : (
    <svg viewBox="0 0 24 24" fill="none" width="18" height="18">
      <path d="M4 6H20M4 12H20M4 18H20" stroke="#1a1f2e" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );

const EventNavbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  // Start with true (mobile) as safe default — corrected after mount
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    // Run immediately on mount to get correct value
    const checkMobile = () => setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    checkMobile();

    const onScroll = () => setScrolled(window.scrollY > 12);

    window.addEventListener("resize", checkMobile, { passive: true });
    window.addEventListener("scroll", onScroll, { passive: true });

    return () => {
      window.removeEventListener("resize", checkMobile);
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const close = () => setOpen(false);

  return (
    <header style={S.header(scrolled, isMobile)}>
      <style>{eventNavStyles}</style>
      <div style={S.inner(isMobile)}>
        
<nav
  style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, borderRadius: 50, padding: "6px 14px" }}
  className={`transition-all duration-300 ${
    scrolled
      ? "glass shadow-soft"
      : "bg-white/40 backdrop-blur-md border border-white/40"
  }`}
>

          {/* Brand */}
          <a href="#top" style={S.brand}>
            <div style={S.logoWrap}>
              <img src="/assets/logo.png" alt="IBH Logo" style={S.logoImg} />
            </div>
            <span className="en-brand-text">
              FREEDOM <span style={S.brandSpan}>CONCLAVE</span>
            </span>
          </a>

          {/* Desktop nav links — only when not mobile */}
          {!isMobile && (
            <ul style={S.desktopLinks}>
              {NAV_LINKS.map((l) => (
                <NavLink key={l.label} href={l.href} label={l.label} />
              ))}
            </ul>
          )}

          {/* Right side */}
          <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
            {!isMobile && (
              <a href="#register" className="en-btn" onClick={(e) => { e.preventDefault(); scrollToSection("#register"); }} aria-label="Jump to Freedom Conclave 2026 registration">
  <span className="en-spark">✦</span>
  Register Now
</a>
            )}

            {isMobile && (
              <button
                aria-label="Toggle menu"
                style={S.hamburger}
                onClick={() => setOpen((prev) => !prev)}
              >
                <HamburgerIcon open={open} />
              </button>
            )}
          </div>
        </nav>

        {/* Mobile dropdown */}
        {isMobile && open && (
          <div style={S.mobileMenu}>
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              {NAV_LINKS.map((l) => (
                <li key={l.label}>
                  <a
                    href={l.href}
                    onClick={(e) => {
                      e.preventDefault();
                      close();
                      setTimeout(() => scrollToSection(l.href), 300);
                    }}
                    style={S.mobileLink}
                    onMouseEnter={e => { e.currentTarget.style.background = "rgba(0,0,0,0.05)"; }}
                    onMouseLeave={e => { e.currentTarget.style.background = "transparent"; }}
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
            <div style={S.mobileBtnWrap}>
              <a
                href="#register"
                onClick={(e) => {
                  e.preventDefault();
                  close();
                  setTimeout(() => scrollToSection("#register"), 300);
                }}
                style={S.mobileBtn}
                onMouseEnter={e => { e.currentTarget.style.opacity = "0.9"; }}
                onMouseLeave={e => { e.currentTarget.style.opacity = "1"; }}
                aria-label="Jump to Freedom Conclave 2026 registration from mobile menu"
              >
                <span className="en-spark">✦</span>
                Register Now
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default EventNavbar;